'use strict';

/**
 *  Load modules
 */
import "@lottiefiles/lottie-player";
import "core-js/stable";
import "regenerator-runtime/runtime";

import menu from './modules/menu.js';
import faq from "./modules/faq.js";
import lotties from './modules/lottie.js';
import projectsSlider from "./modules/projects-slider.js";

import '../scss/app.scss';

const $ = jQuery;

jQuery(function ($) {

    lotties();
    menu();
    faq();
    projectsSlider();


    const scrollTopBtn = document.querySelector('.scroll-top');
    const scrollTopLogo = document.querySelectorAll('.to-top');

    if (scrollTopLogo) {
        scrollTopLogo.forEach(item => {
            item.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

    if (scrollTopBtn) {

        scrollTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });


        window.addEventListener('scroll', () => {
            if (window.scrollY > 300) {
                scrollTopBtn.classList.add('visible');
            } else {
                scrollTopBtn.classList.remove('visible');
            }
        });

    }


    const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');

    anchorLinks.forEach(link => {
        link.addEventListener('click', function (e) {

            const target = document.querySelector(this.hash);

            if (!target) return;

            e.preventDefault();

            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    });

    document.querySelectorAll('.section-value__accordion-item__icon').forEach(icon => {
        icon.addEventListener('mouseenter', () => {
            icon.parentElement.classList.add('active');
        });

        icon.addEventListener('mouseleave', () => {
            icon.parentElement.classList.remove('active');
        });
    });


    if (window.innerWidth < 768) {

        document.querySelectorAll('.mobile-gallery').forEach(gallery => {

            const track = gallery.querySelector('.mobile-gallery__track');
            const dotsContainer = gallery.querySelector('.mobile-gallery__dots');
            const dots = gallery.querySelectorAll('.mobile-gallery__dots button');

            const firstMedia = gallery.querySelector('.mobile-gallery__large-image');
            const secondMedia = gallery.querySelector('.mobile-gallery__small-image');

            
            if (!firstMedia || !secondMedia) {

                if (dotsContainer) {
                    dotsContainer.style.display = 'none';
                }

                return;
            }

            let active = 0;

            function update(index) {

                active = index;

                track.classList.toggle('active', index === 1);

                dots.forEach(dot => {
                    dot.classList.remove('active');
                });

                if (dots[index]) {
                    dots[index].classList.add('active');
                }
            }

            dots.forEach((dot, index) => {

                dot.addEventListener('click', () => {
                    update(index);
                });

            });

            let startX = 0;
            let endX = 0;

            track.addEventListener('touchstart', e => {

                startX = e.touches[0].clientX;
                endX = startX;

            }, { passive: true });

            track.addEventListener('touchmove', e => {

                endX = e.touches[0].clientX;

            }, { passive: true });

            track.addEventListener('touchend', () => {

                const diff = startX - endX;

                if (Math.abs(diff) < 50) return;

                if (diff > 0) {
                    update(1);
                } else {
                    update(0);
                }

            });

        });

    }

    function equalizeGalleryImages() {

    document.querySelectorAll('.mobile-gallery').forEach(gallery => {

        const largeImage = gallery.querySelector('.mobile-gallery__large-image');
        const smallImage = gallery.querySelector('.mobile-gallery__small-image');

        if (!largeImage || !smallImage) return;

        const imageHeight = largeImage.getBoundingClientRect().height;

        if (imageHeight > 0) {
            smallImage.style.height = imageHeight + 'px';
        }

    });

}


// Initial
function initGalleryHeights() {
    equalizeGalleryImages();

    requestAnimationFrame(() => {
        equalizeGalleryImages();
    });

    setTimeout(() => {
        equalizeGalleryImages();
    }, 100);

    setTimeout(() => {
        equalizeGalleryImages();
    }, 500);
}


document.addEventListener('DOMContentLoaded', initGalleryHeights);
window.addEventListener('load', initGalleryHeights);
window.addEventListener('resize', equalizeGalleryImages);


// Watch for dynamically added/replaced gallery elements
const galleryObserver = new MutationObserver(() => {
    equalizeGalleryImages();
});

galleryObserver.observe(document.body, {
    childList: true,
    subtree: true
});

//Gtranslate sinhronization 
    document.addEventListener('click', function (e) {
        const link = e.target.closest('.gtranslate_wrapper .glink');

        if (!link) return;

        setTimeout(() => {
            const lang = link.dataset.gtLang;

            document.querySelectorAll('.gtranslate_wrapper').forEach(wrapper => {
                wrapper.querySelectorAll('.glink').forEach(item => {
                    item.classList.toggle(
                        'gt-current-lang',
                        item.dataset.gtLang === lang
                    );
                });
            });
        }, 300);
    });
});

$(window).on('load', () => {

    AOS.init({
        once: true
    });

    if (typeof AOS.refreshHard === 'function') {
        AOS.refreshHard();
    }
});
